import {mapLegacyPagination} from '@/store/utils'
import '@/store/api/product-inventory/typedefs'
import api from '@/store/api/product-inventory'
import * as mutationTypes from './mutation-types'
// Modules
import productCategory from './product-category'

const initialState = () => ({
    productCategories: {
        data: [],
        pagination: {}
    },
    productCategoriesSearch: {
        data: []
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        productCategories: state => state.productCategories,
        productCategoriesSearch: state => state.productCategoriesSearch
    },
    actions: {
        /**
         * @param {SearchQuery} query
         * @returns {Promise<*>}
         */
        listProductCategories: async ({commit, dispatch}, query) => {
            try {
                const response = await api.productCategories.searchProductCategories(query)
                commit(mutationTypes.SET_CATEGORIES, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {SearchQuery} query
         * @returns {Promise<*>}
         */
        searchProductCategories: async ({commit, dispatch}, query) => {
            try {
                const response = await api.productCategories.searchProductCategories(query)
                commit(mutationTypes.SET_CATEGORIES_SEARCH, response)
                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetProductCategories: async ({commit}) => commit(mutationTypes.RESET_CATEGORIES),
        resetProductCategoriesSearch: async ({commit}) => commit(mutationTypes.RESET_CATEGORIES_SEARCH)
    },
    modules: {
        productCategory
    },
    mutations: {
        [mutationTypes.RESET_CATEGORIES]: state => Object.assign(state, initialState()),
        [mutationTypes.RESET_CATEGORIES_SEARCH]: state => {
            state.productCategoriesSearch = initialState().productCategoriesSearch
        },
        [mutationTypes.SET_CATEGORIES]: (state, data) => {
            state.productCategories = {
                ...data,
                pagination: mapLegacyPagination(data.pagination)
            }
        },
        [mutationTypes.SET_CATEGORIES_SEARCH]: (state, data) => {
            state.productCategoriesSearch = data
        }
    }
}
